export default "__VITE_ASSET__Db9JmrIs__"